import { IImage, ImageSizes } from "@/types/types";

export function getImageWidth(image : IImage) {
  let widths = {} as ImageSizes;
  let crops = image.crops
  for (let alias in crops) {
    let crop = crops[alias];
    let width = crop.width;    
    widths[crop.alias] = `${width}`;    
  }
    return widths;
} 